import {
  AgentMetaCard,
  AgentMetaMonospace,
  type AgentMetaItem,
} from "@/pages/agent/components/agent-meta-card";
import { formatAgentDate } from "@/pages/agent/utils/agent-date.utils";
import { formatStatusLabel } from "@/pages/agent/utils/agent-status.utils";
import type { ProjectDetailViewModel } from "@/pages/agent/project/agent-project-page.utils";

export const AgentProjectMetaCard = ({
  projectDetail,
}: {
  projectDetail: ProjectDetailViewModel;
}) => {
  const { project, openTasksCount, nextFollowUp, followUpCount } = projectDetail;

  const items: AgentMetaItem[] = [
    { label: "Status", value: formatStatusLabel({ status: project.status }) },
    { label: "Open Tasks", value: String(openTasksCount) },
    {
      label: "Created Date",
      value: formatAgentDate({ value: project.createdAt, includeTime: true }),
    },
    {
      label: "Last Update",
      value: formatAgentDate({ value: project.updatedAt, includeTime: true }),
    },
    {
      label: "Last Activity",
      value: project.lastActivityAt
        ? formatAgentDate({ value: project.lastActivityAt, includeTime: true })
        : "—",
    },
    {
      label: "Next Follow-up",
      value: nextFollowUp
        ? formatAgentDate({
            value: nextFollowUp.scheduledFor ?? nextFollowUp.dueAt,
            includeTime: true,
          })
        : "None scheduled",
    },
    { label: "Follow-ups", value: String(followUpCount) },
    { label: "Project ID", value: <AgentMetaMonospace>{project.id}</AgentMetaMonospace> },
  ];

  return <AgentMetaCard items={items} />;
};
